/**
 * 返回顶部组件
 * 使用 Unpoly compiler 实现滚动监听和平滑回顶
 * 通过 data-threshold 属性配置显示阈值（默认 400px）
 */
export class BackToTop {
  private container: HTMLElement;
  private button: HTMLButtonElement | null;
  private threshold: number;
  private handleScroll: () => void;

  constructor(container: HTMLElement) {
    this.container = container;
    this.button = container.querySelector("button");
    this.threshold = Number(container.dataset.threshold) || 400;
    this.handleScroll = this.onScroll.bind(this);
    this.init();
  }

  /**
   * 初始化：绑定滚动监听和点击事件
   */
  private init() {
    // 初始状态检测
    this.onScroll();

    window.addEventListener("scroll", this.handleScroll, { passive: true });
    this.button?.addEventListener("click", () => this.scrollToTop());
  }

  private ticking = false;

  /**
   * 滚动时判断是否超过阈值，切换 .is-visible 类名
   */
  private onScroll() {
    if (this.ticking) return;
    this.ticking = true;

    requestAnimationFrame(() => {
      const shouldShow = window.pageYOffset > this.threshold;
      this.container.classList.toggle("is-visible", shouldShow);
      this.ticking = false;
    });
  }

  /**
   * 平滑滚动回顶部
   */
  private scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  /**
   * 销毁：移除事件监听
   */
  destroy() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  /**
   * 注册 Unpoly 编译器
   * @param selector CSS 选择器
   */
  static compiler(selector: string) {
    up.compiler(selector, (element: Element) => {
      const backToTop = new BackToTop(element as HTMLElement);
      return () => backToTop.destroy();
    });
  }
}
